module.exports = __webpack_public_path__ + "img/features-3.f16402e0.png";